import { reduxForm, getFormValues } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectActiveVenue } from 'selectors/general';
import { asFormSubmit } from 'components/Form';
import { selectInstructors, selectInstructorsIsLoaded } from 'features/Instructors';
import AddScheduleForm from './AddScheduleForm';
import { SCHEDULE_TYPES, getNextSingleDayExceptionDate, isRecurringSchedule } from '../ScheduleForm.helpers';
import { addScheduleSyncValidation as validate } from '../ScheduleForm.validator';
import {
  selectSchedulesClasses,
  selectCreatedClassId,
  selectCreatedInstructorId,
  selectSchedulesClassesIsLoaded,
} from '../../Schedules.selectors';
import { DRAFT_STATUS, PUBLISHED_STATUS } from '../../Schedules.helpers';
import { createSchedule as createScheduleAction } from '../../Schedules.saga';

export const ADD_SCHEDULE_FORM_NAME = 'SCHEDULES/ADD_SCHEDULE_FORM';
const scheduleFormInitialValues = {
  isNoEndDate: true,
  startAndDuration: [{ time: '07:00', durationInMinutes: 60 }],
  startDate: new Date().toISOString(),
  scheduleType: SCHEDULE_TYPES.recurring,
  recurrenceEndDate: new Date().toISOString(),
  recurrence: {},
};

export const mapStateToProps = (state, ownProps) => {
  const { venueId } = selectActiveVenue(state);
  const createdClassId = selectCreatedClassId(state);
  const createdInstructorId = selectCreatedInstructorId(state);
  const classes = selectSchedulesClasses(state, venueId);
  const instructors = selectInstructors(state, venueId);
  const formValues = getFormValues(ADD_SCHEDULE_FORM_NAME)(state) || {};
  const { startAndDuration, scheduleType, isNoEndDate, classId = null, instructorId = null } = formValues;
  const currentFirstDuration = startAndDuration && startAndDuration[0].durationInMinutes;
  const nextSingleDayExceptionDate = getNextSingleDayExceptionDate(formValues);

  return {
    classes,
    currentFirstDuration,
    initialValues: {
      ...scheduleFormInitialValues,
      ...formValues,
      classId: createdClassId || classId,
      instructorId: createdInstructorId || instructorId,
    },
    instructors,
    isLoading: !selectSchedulesClassesIsLoaded(state, venueId) || !selectInstructorsIsLoaded(state, venueId),
    isNoEndDate,
    isRecurring: isRecurringSchedule(scheduleType),
    nextSingleDayExceptionDate,
    ...ownProps,
  };
};

const mapDispatchToProps = {
  createSchedule: createScheduleAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { createSchedule } = dispatchProps;

  return {
    saveAsDraft: asFormSubmit((values, asyncSubmitFns) =>
      createSchedule({ ...values, status: DRAFT_STATUS }, asyncSubmitFns)
    ),
    saveAsPublished: asFormSubmit((values, asyncSubmitFns) =>
      createSchedule({ ...values, status: PUBLISHED_STATUS }, asyncSubmitFns)
    ),
    ...stateProps,
    ...dispatchProps,
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({ form: ADD_SCHEDULE_FORM_NAME, validate, enableReinitialize: true })
)(AddScheduleForm);
